import { Modal } from 'react-bootstrap';
import React from 'react';
import { Button, ButtonBar } from '../../../../common/components';
import { FullRow } from '../../../layout/components';

export const NewScreeningDeclarationConfirmation = ({
  show,
  onConfirm,
  onCancel,
  errorMessage,
}) => {
  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Commission Reallocation</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>There was an issue starting the screening</p>
        <p>Response from Verisk:</p>
        <ul>
          <li>{errorMessage}</li>
        </ul>

        <p>
          {' '}
          In order to change this travellers medical conditions a full re-screen is
          required, NOTE: this will <u>remove</u> all previous screening data.
        </p>
        <p> Do you wish to continue?</p>
      </Modal.Body>
      <Modal.Footer>
        <FullRow>
          <ButtonBar>
            <Button
              bsStyle={'default'}
              label={'cancel'}
              className={'pull-left'}
              handleClick={onCancel}
            />
            <Button
              bsStyle={'primary'}
              label={'Start Full Re-Screen'}
              className={'pull-right'}
              handleClick={onConfirm}
            />
          </ButtonBar>
        </FullRow>
      </Modal.Footer>
    </Modal>
  );
};
